<template>
  <div class="wrapper">
    <div v-if="loading"
         class="circular-loader">
      <base-circular-loader color="primary"
                            size="medium" />
    </div>

    <div v-else
         class="tab-page">
      <div v-if="isScreenTimeExist"
           class="screen-time"
           :class="screenTimeStyles">
        <base-switch class="periods-switch"
                     v-model="selectedPeriod"
                     :options="screenTimePeriods"/>

        <screen-time-chart class="chart"
                           :data="screenTime[selectedPeriodName]"
                           :start-date="startDate"
                           :end-date="currentDate"
                           :chart-period="this.selectedPeriodName"/>
      </div>

      <screen-time-empty-screen v-else
                                :loading="loading"
                                @retry="onRetry" />
    </div>
  </div>
</template>

<script>
  import ScreenTimeChart       from './ScreenTimeChart.vue'
  import ScreenTimeEmptyScreen from './ScreenTimeEmptyScreen.vue'

  import * as intl from '@/services/intl'
  import childApi from '@/api/child.js'
  import analytics from '@/services/analytics.js'
  import i18n from '@/services/i18n'

  const screenTimePeriods = [
    { key: 'WEEK', value: i18n.t("week") },
    { key: 'MONTH', value: i18n.t("month") }
  ]

  export default {
    props: {
      childId: {
        type: String,
        required: true
      }
    },

    components: {
      ScreenTimeChart,
      ScreenTimeEmptyScreen
    },

    data() {
      return {
        loading: false,
        userId: null,
        screenTimePeriods,
        selectedPeriod: screenTimePeriods[0],
        screenTime: {
          week: [],
          month: []
        }
      }
    },

    created() {
      analytics.sendEvent('ScrTimeWk_Tb')
      this.setScreenTime()
    },

    computed: {
      ...mapGetters('auth', {
        locale: 'locale'
      }),

      selectedPeriodName() {
        return this.selectedPeriod.key.toLowerCase()
      },

      startDate() {
        return this.selectedPeriodName === 'week' ? this.weekAgoDate : this.monthAgoDate
      },

      currentDate() {
        return intl.getISODate()
      },

      weekAgoDate() {
        return intl.getISODate(intl.subtractWeek(this.currentDate, 1))
      },

      monthAgoDate() {
        return intl.getISODate(intl.subtractMonth(this.currentDate, 1))
      },

      isScreenTimeExist() {
        return this.screenTime.week.length || this.screenTime.month.length
      },

      screenTimeStyles() {
        return {
          'screen-time-mobile': this.$mq === 'mobile'
        }
      }
    },

    methods: {
      async setScreenTime() {
        this.loading = true

        this.screenTime.week = await childApi.getScreenTime({
          user_id: this.childId,
          min_date: this.weekAgoDate
        })

        this.screenTime.month = await childApi.getScreenTime({
          user_id: this.childId,
          min_date: this.monthAgoDate
        })

        this.loading = false
      },

      onRetry() {
        this.setScreenTime()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .wrapper {
    height: 100%;
    width: 100%;

    .circular-loader {
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tab-page {
      height: 100%;
      width: 100%;

      .screen-time {
        display: flex;
        flex-direction: column;
        height: 100%;
        padding: 24px 14px 14px 14px;
        background-color: #fff;

        .periods-switch {
          width: 515px;
          flex-shrink: 0;
          margin: 0 auto 25px auto;
        }

        .chart {
          flex-grow: 1;
        }
      }

      .screen-time-mobile {
        padding: 12px 14px 14px 14px;

        .periods-switch {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
</style>
